
//  import moment from 'moment';
import { addForm, viewColomn } from '../common';
export const sendcvConfig = {
  api: () => '/sendcv',
  title: 'Send Resume',
  isActionTab: true,
  extraCall: (id) => '/sendcv/send/mail/' + id,
  moreActions: [
    {
      name: 'View PDF',
      action: 'pdf',
      getKey: (value) => value.developer.pdfFile,
      keyDisabled: 'pdfSent',
    },
  ],
  modalTitle: (action) => `${action} Send Request`,
  getColumns: () => {
    return [
      {
        title: 'Company Name',
        dataIndex: 'companyName',
        key: 'companyName',
        isSearch: true,
        render: (text) => {
          return text.companyName;
        }
      },
      {
        title: 'Contact Person',
        dataIndex: '',
        key: '',
        isSearch: true,
        render: (text) => {
          if (text.companyName && text.companyName.contactDetails) {
            const user = text.companyName.contactDetails.filter(ele => ele._id == text.sendMailTo);
            if (user.length > 0) {
              return [user[0].contactPerson, user[0].email].join(' | ');
            } else {
              return 'NA';
            }
          } else {
            return 'NA';
          }
        }
      },
      {
        title: 'Developer Name',
        dataIndex: 'developer',
        key: 'developer',
        render: (text) => {
          return text && text.developerName ? [text.developerName.firstName, text.developerName.lastName, text.experience, text.developerName.role.name].join('_') : '';
        }
      },
      {
        title: 'Budget',
        dataIndex: 'budget',
        key: 'budget',
        render: (text) => {
          return text;
        }
      },
      {
        title: 'Sent',
        dataIndex: 'pdfSent',
        key: 'pdfSent',
        render: (text) => {
          return text ? 'Sent' : 'Pending';
        }
      },
      ...viewColomn(true)
    ];
  },
  getFormColumns: () => {
    return [
      {
        title: 'Company Name',
        dataIndex: 'companyName',
        key: 'companyName',
        isRequired: true,
        type: 'select',
        isCombo: true,
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'Send To',
        dataIndex: 'sendMailTo',
        key: 'sendMailTo',
        isRequired: true,
        type: 'select',
        isCombo: true,
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'Developer',
        dataIndex: 'developer',
        key: 'developer',
        isRequired: true,
        type: 'select',
        isCombo: true,
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'Budget per month',
        dataIndex: 'budget',
        key: 'budget',
        isRequired: true,
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'Reply To',
        dataIndex: 'replyTo',
        key: 'replyTo',
        isRequired: true,
        type: 'select',
        isCombo: true,
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'Job Description',
        dataIndex: 'jobDescription',
        key: 'jobDescription',
        type: 'textQuill',
        formClassName: 'col-12 pb-2',
      },
      {
        title: 'Email Template',
        dataIndex: 'emailTemplate',
        key: 'emailTemplate',
        isRequired: true,
        type: 'select',
        isCombo: true,
        formClassName: 'col-4 pb-2',
      },
      ...addForm()
    ];
  },
  combo: [
    {
      name: 'emailTemplate',
      api: '/cms/emailTemplates',
      idKey: '_id',
      nameKey: ['name'],
    },
    {
      name: 'replyTo',
      api: '/users',
      idKey: '_id',
      nameKey: ['firstName', 'middelName', 'lastName'],
    },
    {
      name: 'companyName',
      api: '/organizations',
      idKey: '_id',
      nameKey: ['companyName'],
    },
    {
      name: 'sendMailTo',
      api: '/clients/contact/',
      idKey: '_id',
      nameKey: ['contactPerson', 'contactPersonRole'],
      paramValue: 'companyName',
      onChange: 'companyName',
      isJoin: ' | '
    },
    {
      name: 'developer',
      api: '/resumes',
      idKey: '_id',
      nameKey: [{ developerName: { firstName: 1, lastName: 1 } }, 'experience', { developerName: { role: { name: 1 } } }],
      isJoin: '_'
    },
    {
      name: 'approvalFrom',
      api: '/users/CEO/list',
      idKey: '_id',
      nameKey: ['firstName', 'middelName', 'lastName'],
    },
  ],
  getData: () => ({}),
  actions: [
    { name: 'Send Resume', isModal: true, settings: { type: 'primary' } },
    { name: 'Return', isBack: true, settings: { type: 'primary' } },
  ],
};
